export class DateFormatter {
  public getYYYYMMDD(inputDate: string): string {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
    const day = String(date.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;
    // Output: 2025-07-17
    return formattedDate;
  }

  public getDottedDDMMYYYY(inputDate: string | null): string | null {
    if (!inputDate) return null;
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
    const day = String(date.getDate()).padStart(2, '0');

    const formattedDate = `${day}.${month}.${year}`;
    // Output: 2025-07-17
    return formattedDate;
  }
}
